import { CSSObject } from "@emotion/react";
import {
  constants,
  typographyStyles,
  visuallyHiddenStyles,
} from "@newsela/angelou";
import {
  e1Gradient,
  gradientWithWhiteBackground,
} from "@/components/AIComponents/AiComponents.style";

const { ui } = constants.colors;
const { textSObj, textMObj, textXSObj } = typographyStyles;

export const wrapperCss: CSSObject = {
  display: "flex",
  alignItems: "center",
  marginInline: "0",
  justifyContent: "space-between",
  padding: 0,
  width: "auto",
  border: "none",
};

export const labelContainerCss: CSSObject = {
  p: {
    ...textMObj,
    margin: 0,
    color: ui.neutral[600],
  },
};

export const legendCss: CSSObject = {
  ...textSObj,
  fontWeight: 700,
  color: ui.neutral[700],
  lineHeight: "114%",

  span: {
    ...textXSObj,
    color: ui.neutral[500],
  },
};

export const radioGroupCss: CSSObject = {
  display: "flex",
  flexDirection: "row",
  gap: "4px",
};

export const radioButtonCss = (isSelected = false): CSSObject => ({
  display: "inline-flex",
  width: "fit-content",
  height: "32px",
  alignItems: "center",
  border: `${isSelected ? 2 : 1}px solid transparent`,
  borderRadius: "100px",
  background: isSelected ? e1Gradient : gradientWithWhiteBackground,
  backgroundClip: "padding-box, border-box",
  padding: "4px 8px",
  color: ui.neutral[700],

  "&:hover, &:focus-within,&:focus-visible": {
    borderColor: "transparent",
    background: e1Gradient,
    backgroundClip: "padding-box, border-box",
    WebkitBackgroundClip: "padding-box, border-box",
    outline: "none",
  },

  ">span": { ...visuallyHiddenStyles },
  ">div": { whiteSpace: "nowrap" },
});
